import { useMutation, UseMutationOptions } from 'react-query';

import { CreditApi } from 'api/CreditApi';
import { CreditsFunnels } from 'helpers/funnels/funnels';

export const useCreditWelcomeGiftMutation = (
  options?: UseMutationOptions<
    { credits: number },
    unknown,
    { funnel: CreditsFunnels },
    unknown
  >
) => {
  return useMutation(CreditApi.getWelcomeGift, options);
};
